import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FormNDY_UB_1 from "../../Forms/FormNDY_UB_1";
import Header from "../../Includes/Layouts/NDY_UB_1/Header.js";
import Footer from "../../Includes/Layouts/NDY_UB_1/Footer.js";
import FbViewPixel from "../../../Utility/FbViewPixel";
import "../../../assets/NDY_UB_1/css/NDY_UB_1.scss";
import Section1 from "../../Includes/Layouts/NDY_UB_1/Section1.js";
import AccordSection from "../../Includes/Layouts/NDY_UB_1/AccordSection";

const NDY_UB_1  = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="NDY_UB_1" />
      <FbViewPixel />
      <div className="NDY_UB_1">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormNDY_UB_1 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default NDY_UB_1;